/// Identificadores gerados no dispositivo. Nada aqui pode depender de rede: a
/// inspeção precisa existir, com id e código definitivos, antes de ver o servidor.

const hex = '0123456789abcdef'

function bytesAleatorios(n: number): Uint8Array {
  const b = new Uint8Array(n)
  globalThis.crypto.getRandomValues(b)
  return b
}

/// UUID v7: 48 bits de timestamp em milissegundos + aleatório. Ordena por tempo de
/// criação, o que mantém o índice do Postgres compacto mesmo com id vindo do cliente.
export function uuidv7(agora: number = Date.now()): string {
  const b = bytesAleatorios(16)
  // 48 bits de timestamp, big-endian
  b[0] = (agora / 2 ** 40) & 0xff
  b[1] = (agora / 2 ** 32) & 0xff
  b[2] = (agora / 2 ** 24) & 0xff
  b[3] = (agora / 2 ** 16) & 0xff
  b[4] = (agora / 2 ** 8) & 0xff
  b[5] = agora & 0xff
  b[6] = (b[6]! & 0x0f) | 0x70 // versão 7
  b[8] = (b[8]! & 0x3f) | 0x80 // variante RFC 4122

  let s = ''
  for (let i = 0; i < 16; i++) {
    if (i === 4 || i === 6 || i === 8 || i === 10) s += '-'
    s += hex[b[i]! >> 4]! + hex[b[i]! & 0x0f]!
  }
  return s
}

/// Código da inspeção: `{cod_obra}-{8 caracteres}`.
///
/// Mesma regra do Power Apps, e pelo mesmo motivo: dois dispositivos offline não podem
/// negociar um "último número + 1". O sufixo vem do id da inspeção, então o código é
/// determinístico — reprocessar a mesma inspeção gera o mesmo código.
export function gerarCodigoInspecao(codigoObra: string | null | undefined, inspecaoId: string): string {
  const obra = (codigoObra ?? '').trim() || '0000'
  const sufixo = inspecaoId.replace(/-/g, '').slice(0, 8).toUpperCase()
  return `${obra}-${sufixo}`
}

/// Cabeçalho da assinatura, no formato que o Power Apps grava hoje. Mantido idêntico
/// para o histórico migrado e o novo ficarem consistentes no mesmo relatório.
export function cabecalhoAssinatura(nome: string, em: Date = new Date()): string {
  return `${nome} - ${formatarDataHora(em)}`.slice(0, 100)
}

const doisDigitos = (n: number) => String(n).padStart(2, '0')

export function formatarData(d: Date): string {
  return `${doisDigitos(d.getDate())}/${doisDigitos(d.getMonth() + 1)}/${d.getFullYear()}`
}

export function formatarDataHora(d: Date): string {
  return `${formatarData(d)} ${doisDigitos(d.getHours())}:${doisDigitos(d.getMinutes())}`
}

/// Data pura `aaaa-mm-dd` no fuso local. Usar `toISOString()` aqui erraria o dia para
/// quem registra a inspeção à noite (UTC-3 vira o dia seguinte).
export function paraDataIso(d: Date): string {
  return `${d.getFullYear()}-${doisDigitos(d.getMonth() + 1)}-${doisDigitos(d.getDate())}`
}

export function deDataIso(iso: string): Date {
  const [a, m, d] = iso.split('-').map(Number) as [number, number, number]
  return new Date(a, m - 1, d)
}
